import {
  AssignmentOutlined,
  CheckRounded,
  CopyAll,
  OpenInNew,
} from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import LoanBorrowerAssignFilesModal from "../../../../screens/LoanDrilldownScreen/tabs/LoanDrilldownBorrowersTab/LoanDrilldownBorrowersTabRedesign/LoanBorrowerAssignFilesModal";
import { useDispatch, useSelector } from "react-redux";
import BasicModal from "../../../modals/BasicModal";
import SearchInput from "../../../inputs/SearchInput";
import Flx from "../../../layout/Flx";
import { green, grey } from "@mui/material/colors";
import { isNil } from "lodash";
import { useBorrowerSubmissionsHook } from "../../../../hooks/useBorrowerSubmissionsHook";
import Txt from "../../../typography/Txt";
import { formatBorrowerObjectFullName } from "../../../../_src_shared/utils/functions/formatBorrowerObjectFullName";

const SendBorrowerAppLinkButton = ({
  borrower,
  variant = "outlined",
  color = "gray",
  size = "medium",
  sx,
  type,
  icon,
  children,
}) => {
  // loan app TextSnippet | CreditScore
  const [show, setShow] = useState(false);
  return (
    <>
      <Button
        onClick={() => setShow(true)}
        // maxWidth="unset"
        color={color}
        variant={variant}
        size={size}
        //   maxWidth="165px"
        // disabled
        // iconSize={18}
        sx={{
          // ml: 2,
          flexGrow: 1,
          // fontStyle: "italic",
          // fontWeight: 400,
        }}
        text={"Assign Existing File"}
        startIcon={icon}
      >
        {children || "Send App Link"}
      </Button>
      <BorrowerCreditAuthUrlModal
        show={show}
        type={type}
        borrower={borrower}
        onClose={() => setShow(false)}
      />
    </>
  );
};

const BorrowerCreditAuthUrlModal = ({
  borrowerId,
  type, // loanApp | creditAuth
  borrower,
  show,
  onClose,
}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const [url, setUrl] = useState(null);
  const { loading, generateDealApplicationLink, generateDealCreditAuthLink } =
    useBorrowerSubmissionsHook();

  const modalTitle = useMemo(() => {
    const fullName = formatBorrowerObjectFullName(borrower);
    if (type === "creditAuth") {
      return `${fullName} Credit Authorization`;
      // return `Credit Authorization Link`;
    }
    if (type === "loanApp") {
      return `${fullName} Loan Application`;
      // return `Loan Application Link`;
    }
    return "Borrower Link";
  }, [type, borrower]);

  const bodyText = useMemo(() => {
    const fullName = formatBorrowerObjectFullName(borrower);
    if (type === "creditAuth") {
      // return `For ${fullName}`;
      return `Credit Authorization URL`;
      // return `Credit Authorization for ${fullName}`;
      // return `${fullName} Credit Authorization`;
    }
    if (type === "loanApp") {
      // return `For ${fullName}`;
      return `Loan Application URL`;
      // return `Loan Application for ${fullName}`;
      // return `${fullName} Loan Application`;
    }
    return "Borrower Link";
  }, [type, borrower]);

  const handleOnClose = useCallback((props) => {
    onClose();
    setUrl(null);
  }, []);

  useEffect(() => {
    if (show && isNil(url)) {
      if (type === "creditAuth") {
        generateDealCreditAuthLink({
          loanId: loanDrilldown?._id,
          borrowerData: borrower,
          onSuccessFn: (d) => {
            setUrl(d?.link);
          },
        });
        return;
      }
      if (type === "loanApp") {
        generateDealApplicationLink({
          loanId: loanDrilldown?._id,
          borrowerData: borrower,
          onSuccessFn: (d) => {
            setUrl(d?.link);
          },
        });
        return;
      }
    }
  }, [show]);

  if (!show) {
    return null;
  }
  return (
    <BasicModal
      description={"Copy and share the following link with the borrower"}
      // description={
      //   "This URL includes metadata that tracks the submission for this user. Please do not modify."
      // }
      title={modalTitle}
      maxWidth="sm"
      onClose={handleOnClose}
      show={show}
    >
      <UrlCopyAndPaste url={url} urlText={bodyText} loading={loading} />
    </BasicModal>
  );
};

const UrlCopyAndPaste = ({ url, urlText, loading }) => {
  const [copied, setCopied] = useState(false);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
  };

  const styles = useMemo(() => {
    return {
      urlText: { fontSize: "13px" },
      urlTextDescription: { fontStyle: "italic" },
      urlBox: {
        p: 1,
        background: grey[100],

        whiteSpace: "nowrap",
        display: "flex",
        overflow: "hidden",
        // position: "relative",
        // display: "inline-block",
        // textOverflow: "ellipsis",
        // whiteSpace: "nowrap",
      },
      urlBoxText: {
        fontSize: "12px",
        //
        // textOverflow: "ellipsis",
      },
    };
  }, []);

  // if (!url) {
  //   return null;
  // }

  return (
    <Flx fw column gap={1}>
      <Flx column>
        <Txt sx={styles.urlText} bold>
          {urlText}
        </Txt>

        <Txt secondary sx={styles.urlTextDescription}>
          This URL includes metadata that tracks the submission for this user.
          Please do not modify.
        </Txt>
      </Flx>
      <Box
        sx={{
          // p: 1,
          pr: 0,
          background: grey[100],
          whiteSpace: "nowrap",
          borderRadius: 1,
          border: `1px solid ${grey[200]}`,
          display: "flex",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Flx fw jb ac gap={1} sx={{ overflowX: "auto", p: 1.4, pt: 2 }}>
          <Txt sx={styles.urlBoxText}>
            {loading ? (
              <Flx fw center>
                <CircularProgress size={16} />
              </Flx>
            ) : (
              url
            )}
          </Txt>
        </Flx>
        <Flx
          jb
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            background: "#f5f5f5",
            height: 44,
            borderLeft: `1px solid ${grey[300]}`,
            // px: 1,
            // pt: 1,
            // alignItems: "flex-start",
          }}
        >
          <Tooltip
            title={copied ? "Copied To Clipboard" : "Copy To Clipboard"}
            arrow
          >
            <IconButton
              role="link"
              color={copied ? "success" : "primary"}
              onClick={handleCopyToClipboard}
              sx={{
                background: copied ? green[50] : "inherit",
                height: "100%",
                borderRadius: 0,
                px: 1.4,
              }}
              size="small"
            >
              {copied ? <CheckRounded /> : <CopyAll />}
            </IconButton>
          </Tooltip>
          <Tooltip title="Open in new tab" arrow>
            <IconButton
              role="link"
              href={url}
              color="primary"
              size="small"
              sx={{ height: "100%", px: 1.4, borderRadius: 0 }}
              target="_blank"
            >
              <OpenInNew />
            </IconButton>
          </Tooltip>
        </Flx>
      </Box>
    </Flx>
  );
};

export default SendBorrowerAppLinkButton;
